import {Component, EventEmitter, OnInit, Output, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {StandardSubjectFormComponent} from '../standard-subject-form.component';
import {fourOrNineSinValidator,dateValidator} from '../../../../_utils/validators';
import {ACCOUNT_NUMBER_PATTERN, ADDRESS_PATTERN, POSTAL_PATTERN} from '../../../../_constants/constants';
import {NgClass} from '@angular/common';
import {HideOnBlurDirective} from '../../../../_directives/hide-on-blur.directive';
import {NgxMaskModule} from 'ngx-mask';
import {ValidationErrorsComponent as ValidationErrorsComponent_1} from '../../../../common/forms/validation-errors/validation-errors.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-avs-subject-form',
    templateUrl: './avs-subject-form.component.html',
    styleUrls: ['./avs-subject-form.component.scss'],
    imports: [StandardSubjectFormComponent, ReactiveFormsModule, NgClass, HideOnBlurDirective, NgxMaskModule, ValidationErrorsComponent_1, TranslateModule]
})
export class AvsSubjectFormComponent implements OnInit {

  @Output() submittedData: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  @Output() back: EventEmitter<void> = new EventEmitter<void>();

  subjectFormGroup: UntypedFormGroup;
  identificationFormGroup: UntypedFormGroup;
  addressFormGroup: UntypedFormGroup;

  /**
   * This gets passed to the nested validation-error components.
   *
   * @see {@link ValidationErrorsComponent.displayErrors}
   */
  displayErrors: boolean;
  private formBuilder = inject(UntypedFormBuilder);

  constructor() {
    const formBuilder = this.formBuilder;


    this.subjectFormGroup = StandardSubjectFormComponent.buildSubjectFormGroup(formBuilder);
    this.addressFormGroup = AvsSubjectFormComponent.buildAvsAddressFormGroup(formBuilder);

    this.identificationFormGroup = this.formBuilder.group({
      dob: ['', dateValidator],
      sin: ['', fourOrNineSinValidator], //For AVSS (note: extra S)
      cc:  ['', Validators.compose([Validators.required, Validators.maxLength(32), Validators.pattern(ACCOUNT_NUMBER_PATTERN)])]
    });

  }

  static buildAvsAddressFormGroup(formBuilder: UntypedFormBuilder) {
    return StandardSubjectFormComponent.buildAddressFormGroup(formBuilder, {
      street:       ['', Validators.compose([Validators.maxLength(128), Validators.pattern(ADDRESS_PATTERN)])],
      city:         ['', Validators.compose([Validators.maxLength(32), Validators.pattern(ADDRESS_PATTERN)])],
      postalCode:   ['', Validators.compose([Validators.maxLength(8), Validators.pattern(POSTAL_PATTERN)])],
      province:     ''
    });
  }

  ngOnInit(): void {
  }

}
